/*
  LANDING MADE IN ITALY + PROMO — l'offerta.

  Una sola scelta per tutta la pagina: la sezione dopo il confronto e quella
  ripetuta in fondo leggono e scrivono lo stesso stato, e la barra fissa ci si
  appoggia. Per questo lo stato sta qui fuori e non dentro l'istanza.

  26/09/2026 — SI SCELGONO TUTTE E DUE LE BORSE.
  Prima la principale era fissa: chi voleva partire da un altro modello non
  aveva modo di farlo. Adesso ci sono due gallerie, la stessa lista per
  entrambe, e ognuna esclude la borsa gia' scelta nell'altra. La borsa
  impostata nella sezione resta quella preselezionata, quindi chi non tocca
  niente vede esattamente quello che vedeva prima.

  IL PREZZO
  prezziCoppia() e' l'unico punto in cui si decide chi prende lo sconto. La
  regola di oggi ('second_half') e' quella dello sconto automatico gia' attivo
  sul negozio: il 50% va alla borsa MENO CARA della coppia, a parita' alla
  seconda. La pagina non applica nulla: mostra quello che il carrello fara'.
  Quando arrivera' la landing "2 borse a 199" bastera' aggiungere un ramo qui.
*/
(function () {
  'use strict';

  var stato = {
    opzione: 'coppia',   /* 'sola' | 'coppia' */
    principale: null,
    seconda: null,
    filtro: '',
    totale: 0
  };
  var istanze = [];

  function euro(centesimi) {
    return '€' + (centesimi / 100).toFixed(2).replace('.', ',');
  }

  function prezziCoppia(principale, seconda, modo) {
    if (modo !== 'second_half' || !seconda) {
      return {prima: principale.prezzo, seconda: 0, sconto: 0, scontaPrincipale: false};
    }
    var menoCara = Math.min(principale.prezzo, seconda.prezzo);
    var sconto = Math.round(menoCara / 2);
    /* A parita' di prezzo lo sconto va alla seconda: stessa scelta del modulo
       che gira sulle schede prodotto, cosi' i due posti non si contraddicono. */
    var scontaPrincipale = principale.prezzo < seconda.prezzo;
    return {
      prima: scontaPrincipale ? principale.prezzo - sconto : principale.prezzo,
      seconda: scontaPrincipale ? seconda.prezzo : seconda.prezzo - sconto,
      sconto: sconto,
      scontaPrincipale: scontaPrincipale
    };
  }

  function annuncia() {
    document.dispatchEvent(new CustomEvent('vxmip:stato', {detail: {
      opzione: stato.opzione,
      principale: stato.principale,
      seconda: stato.seconda,
      totale: stato.totale
    }}));
  }

  function prepara(sezione) {
    if (sezione.dataset.vxofPronta === '1') return;
    sezione.dataset.vxofPronta = '1';

    var dati;
    try { dati = JSON.parse(sezione.querySelector('[data-vxof-dati]').textContent); }
    catch (e) { return; }
    if (!dati || !dati.candidate || !dati.candidate.length) return;

    var modo = sezione.getAttribute('data-pricing') || 'second_half';
    var etichettaSconto = sezione.getAttribute('data-etichetta') || 'La paghi la metà';
    var compatta = sezione.getAttribute('data-layout') === 'compact';

    var ops    = sezione.querySelectorAll('[data-vxof-op]');
    var blocco = sezione.querySelector('[data-vxof-scelta]');
    var passo2 = sezione.querySelector('[data-vxof-passo2]');
    var compra = sezione.querySelector('[data-vxof-compra]');
    var errore = sezione.querySelector('[data-vxof-errore]');
    var testoCompra = compra ? compra.textContent.trim() : "Completa l'ordine";

    /* L'ordine segue la classifica dei piu' venduti; chi non e' in classifica
       va in fondo, nell'ordine della collezione. */
    var posizione = {};
    (dati.classifica || []).forEach(function (id, i) { posizione[id] = i; });
    var candidate = dati.candidate.slice().sort(function (a, b) {
      var pa = posizione[a.id], pb = posizione[b.id];
      if (pa === undefined && pb === undefined) return 0;
      if (pa === undefined) return 1;
      if (pb === undefined) return -1;
      return pa - pb;
    });

    if (!stato.principale) {
      stato.principale = candidate.filter(function (c) { return c.id === dati.predefinita; })[0]
        || candidate.filter(function (c) { return c.disp; })[0] || null;
    }
    if (!stato.seconda) {
      stato.seconda = candidate.filter(function (c) {
        return c.disp && (!stato.principale || c.id !== stato.principale.id);
      })[0] || null;
    }

    /* ---------------- le gallerie ---------------- */
    function disegnaPista(tipo) {
      var pista = sezione.querySelector('[data-vxof-pista="' + tipo + '"]');
      if (!pista) return;
      var esclusa = tipo === 'principale' ? stato.seconda : stato.principale;
      var scelta  = tipo === 'principale' ? stato.principale : stato.seconda;
      pista.innerHTML = '';
      candidate
        .filter(function (c) { return !esclusa || c.id !== esclusa.id; })
        .filter(function (c) { return !stato.filtro || (c.materiale || '') === stato.filtro; })
        .forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'vxof__card';
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', scelta && scelta.id === c.id ? 'true' : 'false');
          if (!c.disp) b.setAttribute('disabled', 'true');
          b.innerHTML =
            '<span class="vxof__cardfoto">' +
              '<img src="' + (c.img || '') + '" alt="" width="168" height="168" loading="lazy" decoding="async">' +
              '<span class="vxof__cardspunta" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg></span>' +
            '</span>' +
            '<span class="vxof__cardnome">' + c.titolo + '</span>' +
            '<span class="vxof__cardmat">' + [c.materiale, c.colore].filter(Boolean).join(' · ') + '</span>' +
            '<span class="vxof__cardprezzo">' + euro(c.prezzo) + '</span>';
          b.addEventListener('click', function () {
            if (!c.disp) return;
            if (tipo === 'principale') { stato.principale = c; }
            else { stato.seconda = c; stato.opzione = 'coppia'; }
            tuttiAggiornano();
            apriScheda(c);
          });
          pista.appendChild(b);
        });
    }

    function disegna() { disegnaPista('principale'); disegnaPista('seconda'); }

    [].forEach.call(sezione.querySelectorAll('[data-vxof-chip]'), function (chip) {
      chip.addEventListener('click', function () {
        stato.filtro = chip.getAttribute('data-vxof-chip') || '';
        tuttiAggiornano();
      });
    });

    ['principale', 'seconda'].forEach(function (tipo) {
      var pista = sezione.querySelector('[data-vxof-pista="' + tipo + '"]');
      var prec  = sezione.querySelector('[data-vxof-prec="' + tipo + '"]');
      var succ  = sezione.querySelector('[data-vxof-succ="' + tipo + '"]');
      if (prec && pista) prec.addEventListener('click', function () { pista.scrollBy({left: -360, behavior: 'smooth'}); });
      if (succ && pista) succ.addEventListener('click', function () { pista.scrollBy({left: 360, behavior: 'smooth'}); });
    });

    [].forEach.call(ops, function (op) {
      function scegli() {
        stato.opzione = op.getAttribute('data-vxof-op');
        tuttiAggiornano();
      }
      op.addEventListener('click', scegli);
      op.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); scegli(); }
      });
    });

    /* ---------------- il riepilogo ---------------- */
    function aggiorna() {
      var p = stato.principale;
      if (!p) return;
      var coppia = stato.opzione === 'coppia' && stato.seconda;
      var calc = coppia ? prezziCoppia(p, stato.seconda, modo)
                        : {prima: p.prezzo, seconda: 0, sconto: 0, scontaPrincipale: false};

      [].forEach.call(ops, function (op) {
        var attiva = op.getAttribute('data-vxof-op') === stato.opzione;
        op.setAttribute('aria-checked', attiva ? 'true' : 'false');
        op.setAttribute('tabindex', attiva ? '0' : '-1');
      });

      function scrivi(sel, testo) {
        var el = sezione.querySelector(sel);
        if (el) el.textContent = testo || '';
      }

      scrivi('[data-vxof-op1nome]', p.titolo);
      scrivi('[data-vxof-p1]', euro(p.prezzo));
      scrivi('[data-vxof-b1]', p.listino > p.prezzo ? euro(p.listino) : '');

      if (stato.seconda) {
        var c2 = prezziCoppia(p, stato.seconda, modo);
        var pieno = p.prezzo + stato.seconda.prezzo;
        scrivi('[data-vxof-p2]', euro(c2.prima + c2.seconda));
        scrivi('[data-vxof-b2]', euro(pieno));
        scrivi('[data-vxof-risparmio]', 'Risparmi ' + euro(c2.sconto));
      } else {
        scrivi('[data-vxof-p2]', '—');
        scrivi('[data-vxof-b2]', '');
        scrivi('[data-vxof-risparmio]', '');
      }

      if (blocco) blocco.hidden = compatta;
      if (passo2) passo2.hidden = stato.opzione !== 'coppia';

      var mini1 = sezione.querySelector('[data-vxof-mini1]');
      if (mini1) mini1.src = p.img || '';
      scrivi('[data-vxof-nome1]', p.titolo);
      scrivi('[data-vxof-r1]', euro(calc.prima));
      scrivi('[data-vxof-meta1]', coppia && calc.scontaPrincipale ? ' · ' + etichettaSconto : '');

      var riga2 = sezione.querySelector('[data-vxof-riga2]');
      if (riga2) {
        riga2.hidden = !coppia;
        if (coppia) {
          var mini2 = sezione.querySelector('[data-vxof-mini2]');
          if (mini2) mini2.src = stato.seconda.img || '';
          scrivi('[data-vxof-nome2]', stato.seconda.titolo);
          scrivi('[data-vxof-meta2]', calc.scontaPrincipale ? '' : ' · ' + etichettaSconto);
          scrivi('[data-vxof-r2]', euro(calc.seconda));
        }
      }

      var totale = calc.prima + (coppia ? calc.seconda : 0);
      stato.totale = totale;
      scrivi('[data-vxof-totale]', euro(totale));
      var pienoTot = p.prezzo + (coppia ? stato.seconda.prezzo : 0);
      scrivi('[data-vxof-totalebar]', pienoTot > totale ? euro(pienoTot) : '');

      if (compra) compra.textContent = testoCompra + ' · ' + euro(totale);

      [].forEach.call(sezione.querySelectorAll('[data-vxof-chip]'), function (chip) {
        chip.setAttribute('aria-pressed', (chip.getAttribute('data-vxof-chip') || '') === stato.filtro ? 'true' : 'false');
      });
    }

    /* ---------------- la scheda rapida ----------------
       Chi sceglie una borsa la vede da vicino senza uscire dalla pagina:
       foto, prezzo e descrizione arrivano da /products/<handle>.js, chiesti
       solo al primo bisogno e poi tenuti da parte. Se la chiamata non va a
       buon fine si mostra comunque quello che sappiamo gia' (foto piccola,
       nome e prezzo) invece di aprire un riquadro vuoto. */
    var qv       = sezione.querySelector('[data-vxof-qv]');
    var qvCorpo  = sezione.querySelector('[data-vxof-qvcorpo]');
    var qvOk     = sezione.querySelector('[data-vxof-qvok]');
    var schede   = {};
    var scrollBloccato = '';

    function chiudiScheda() {
      if (!qv) return;
      qv.hidden = true;
      document.body.style.overflow = scrollBloccato;
    }

    function disegnaScheda(c, dati2) {
      var foto = (dati2 && dati2.images && dati2.images.length ? dati2.images : [c.img])
        .slice(0, 6)
        .map(function (u) {
          var src = String(u).indexOf('//') === 0 ? 'https:' + u : u;
          return '<img src="' + src + '&width=700" alt="" loading="lazy" decoding="async">';
        }).join('');
      var prezzo = dati2 ? dati2.price : c.prezzo;
      var listino = dati2 ? (dati2.compare_at_price || 0) : c.listino;
      qvCorpo.innerHTML =
        '<div class="vxof__qvfoto">' + foto + '</div>' +
        '<h3 class="vxof__qvtitolo">' + c.titolo + '</h3>' +
        '<p class="vxof__qvmat">' + [c.materiale, c.colore].filter(Boolean).join(' · ') + '</p>' +
        '<p class="vxof__qvprezzo">' + euro(prezzo) +
          (listino > prezzo ? '<span class="vxof__qvbarrato">' + euro(listino) + '</span>' : '') +
        '</p>' +
        '<div class="vxof__qvtesto">' + ((dati2 && dati2.description) || '') + '</div>';
      qvCorpo.scrollTop = 0;
    }

    function apriScheda(c) {
      if (!qv || !qvCorpo) return;
      scrollBloccato = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      qv.hidden = false;
      disegnaScheda(c, schede[c.handle] || null);
      if (!c.handle || schede[c.handle]) return;
      fetch('/products/' + c.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) return;
          schede[c.handle] = d;
          if (!qv.hidden) disegnaScheda(c, d);
        })
        .catch(function () { /* resta la versione essenziale */ });
    }

    [].forEach.call(sezione.querySelectorAll('[data-vxof-qvchiudi]'), function (x) {
      x.addEventListener('click', chiudiScheda);
    });
    if (qvOk) qvOk.addEventListener('click', chiudiScheda);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && qv && !qv.hidden) chiudiScheda();
    });

    /* ---------------- acquisto ---------------- */
    if (compra) {
      compra.addEventListener('click', function () {
        if (errore) errore.hidden = true;
        if (!stato.principale) return;
        if (stato.opzione === 'coppia' && !stato.seconda) {
          if (errore) { errore.textContent = 'Scegli la seconda borsa per continuare.'; errore.hidden = false; }
          return;
        }
        var righe = [{id: Number(stato.principale.id), quantity: 1}];
        if (stato.opzione === 'coppia') righe.push({id: Number(stato.seconda.id), quantity: 1});
        if (dati.omaggio && dati.omaggio.id) righe.push({id: Number(dati.omaggio.id), quantity: 1});

        compra.setAttribute('disabled', 'true');
        compra.textContent = 'Un attimo…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: righe})
        }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        }).then(function () {
          /* 30/09/2026 — se il cliente e' passato prima dalla landing dei
             199, quel codice e' rimasto attaccato alla sessione e al
             checkout farebbe pagare 199 invece del prezzo di questa
             pagina. Lo si toglie qui, prima di andare avanti: svuotare il
             carrello non basta, serve /cart/update.js con discount vuoto.
             La guardia generale fa lo stesso lavoro, ma qui si aspetta la
             risposta, cosi' non si corre contro il cambio di pagina. */
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({discount: ''})
          }).catch(function () {});
        }).then(function () {
          try { document.dispatchEvent(new CustomEvent('ARMADA:LOAD:CART', {detail: {}})); } catch (e) {}
          window.location.href = '/checkout';
        }).catch(function (err) {
          compra.removeAttribute('disabled');
          aggiorna();
          if (errore) {
            errore.textContent = 'Qualcosa non ha funzionato. Riprova o scrivici su WhatsApp.';
            errore.hidden = false;
          }
          if (window.console) console.warn('[vx-mip] aggiunta fallita:', err);
        });
      });
    }

    istanze.push({disegna: disegna, aggiorna: aggiorna});
    disegna();
    aggiorna();
  }

  function tuttiAggiornano() {
    istanze.forEach(function (i) { i.disegna(); i.aggiorna(); });
    annuncia();
  }

  function avvia() {
    [].forEach.call(document.querySelectorAll('[data-vxof]'), prepara);
    annuncia();
  }

  window.vxMipCompra = function () {
    var b = document.querySelector('[data-vxof-compra]');
    if (b) b.click();
  };

  if (document.readyState !== 'loading') { avvia(); }
  else { document.addEventListener('DOMContentLoaded', avvia); }
  document.addEventListener('shopify:section:load', avvia);
})();
